export interface UserLoginDto {
  email: string;
  password: string;
}

export interface RegisterSuperAdminDto {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  referral?: string;
  cardToken?: string;
  redirect?: string;
}

export interface SignUpVerificationDto {
  email: string;
  confirmationCode: string;
}

export enum UserAccess {
  MEMBER,
  ADMIN,
  SUPER_ADMIN,
  NULL
}

export interface AuthChangeTemporaryPasswordDto {
  email: string;
  password: string;
  newPassword: string;
}

export interface AuthResetPasswordRequestDto {
  email: string;
}

export interface AuthResetPasswordDto {
  email: string;
  code: string;
  password: string;
}

export interface AuthUpdatePasswordDto {
  email: string;
  oldPassword: string;
  newPassword: string;
}

export interface User {
  _id: string;
  cognitoId: string;
  firstName: string;
  lastName: string;
  email: string;
  avatarPath: string;
  role: UserAccess;
  createdAt: number;
  organisation: string;
  isActive: boolean;
  isInCustomOrganisation: boolean;
  hasCompletedOnboarding: boolean;
}

export interface UserInviteDto {
  email: string;
  firstName: string;
  lastName: string;
  role: UserAccess;
}

export interface InviteUserStatusDto {
  email: string;
  success: boolean;
  user?: User;
  message?: string;
}

export interface UpdateUserRoleDto {
  userId: string;
  role: UserAccess;
}

export interface UpdateAvatarDto {
  avatarUrl: string;
}

export enum USER_STATUS {
  INACTIVE = '0',
  PENDING = '1',
  ACTIVE = '2'
}

export const UserAccessMap = new Map<string, UserAccess>([
  ['0', UserAccess.MEMBER],
  ['1', UserAccess.ADMIN],
  ['2', UserAccess.SUPER_ADMIN]
]);
